// @flow
import { useEffect, useId, useState } from 'react';
// Style
import './ItemOptionSwitch.css';

type Props = {
  label: string,
  icon: string,
  info: string,
  checked: boolean,
  onChange: (checked: boolean) => void,
};

const ItemOptionSwitch = ({ label, icon, info, checked, onChange }: Props) => {
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const infoId = useId();

  useEffect(() => {
    if (!isInfoOpen) return;
    const closeOnEscape = e => {
      if (e.key === 'Escape') setIsInfoOpen(false);
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [isInfoOpen]);

  return (
    <div className="item-option-switch">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        className={`item-option-switch-button${checked ? ' is-active' : ''}`}
        onClick={() => onChange(!checked)}
      >
        <i className={`fa ${icon}`} aria-hidden="true" />
        {label}
        <span className="item-option-switch-toggle" aria-hidden="true">
          <span />
        </span>
      </button>
      <span
        onMouseEnter={() => setIsInfoOpen(true)}
        onMouseLeave={() => setIsInfoOpen(false)}
      >
        <button
          type="button"
          className="item-option-switch-info-button"
          aria-label={`Sobre ${label}`}
          aria-describedby={infoId}
          onClick={() => setIsInfoOpen(true)}
          onFocus={() => setIsInfoOpen(true)}
          onBlur={() => setIsInfoOpen(false)}
        >
          <i className="fa fa-info-circle" aria-hidden="true" />
        </button>
        <span
          id={infoId}
          role="tooltip"
          className={`item-option-switch-info${isInfoOpen ? ' is-open' : ''}`}
        >
          {info}
        </span>
      </span>
    </div>
  );
};

export default ItemOptionSwitch;
